export default __webpack_public_path__ + "static/media/coin-sidebar-icon.851f53ff.svg";